import styled from 'styled-components';
import { rem } from 'polished';

import { default as BaseContainer } from 'Shared/Container';

export const Container = styled(BaseContainer)`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${rem(12)} ${rem(24)};

  @media screen and (min-width: 834px) {
    padding: ${rem(32)};
  }

  @media screen and (min-width: 1024px) {
    padding-right: ${rem(40)};
    padding-left: ${rem(40)};
  }
`;
